// extracted by mini-css-extract-plugin
export default {"container":"styles_container__T5bCw","deck":"styles_deck__yBp7S","cardImage":"styles_cardImage__wB14c"};